if (!customElements.get('dami-shipping')) {
  customElements.define(
    'dami-shipping',
    class DamiShipping extends HTMLElement {
      constructor() {
        super();
        this.shipTxt = this.querySelector('#shipTxt');
      }

      connectedCallback() {
        const mensaje = this.shipTxt.innerHTML;
        const local = new Date();
        const horaNY = new Date(local.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const hora = horaNY.getHours();
        const dia = horaNY.getDay();
        let txtX = "XXX", fecha1 = null, fecha2 = null;
        const mes = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Set", "Oct", "Nov", "Dec"];
        switch (dia) {
          case 1:
          case 2:
          case 3:
            if(hora > 0 && hora < 16) {
              fecha1 = new Date(horaNY.getTime()+(2*86400000));
              fecha2 = new Date(horaNY.getTime()+(3*86400000));
              break;
            }else{
              fecha1 = new Date(horaNY.getTime()+(3*86400000));
              fecha2 = new Date(horaNY.getTime()+(4*86400000));
              break;
            }
          case 4:
            if(hora > 0 && hora < 16) {
              fecha1 = new Date(horaNY.getTime()+(4*86400000));
              fecha2 = new Date(horaNY.getTime()+(5*86400000));
              break;
            }else{
              fecha1 = new Date(horaNY.getTime()+(5*86400000));
              fecha2 = new Date(horaNY.getTime()+(5*86400000));
              break;
            }
          case 5:
            if(hora > 0 && hora < 13) {
              fecha1 = new Date(horaNY.getTime()+(4*86400000));
              fecha2 = new Date(horaNY.getTime()+(5*86400000));
              break;
            }else{
              fecha1 = new Date(horaNY.getTime()+(5*86400000));
              fecha2 = new Date(horaNY.getTime()+(6*86400000));
              break;
            }
          case 6:
            fecha1 = new Date(horaNY.getTime()+(4*86400000));
            fecha2 = new Date(horaNY.getTime()+(5*86400000));
          default:
            fecha1 = new Date(horaNY.getTime()+(3*86400000));
            fecha2 = new Date(horaNY.getTime()+(4*86400000));
        }
        if(dia == 4) {
          txtX = `${mes[fecha1.getMonth()]} ${fecha1.getDate()}`;
        }else{
          txtX = `${mes[fecha1.getMonth()]} ${fecha1.getDate()} ~ ${mes[fecha2.getMonth()]} ${fecha2.getDate()}`;
        }
        this.shipTxt.innerHTML = mensaje.replace("XXX", txtX);
      }
    }
  )
}
